<template>
  <Modal v-if="showModal" @close="$emit('closeModal')">
    <Loading v-if="loading" />
    <div class="addDescription">
      <div class="addDescription__header">
        <span class="title">
          {{ isAddDescription ? $t('addDescription') : $t('infoReservation') }}
        </span>
        <img
          src="@/assets/icons/CloseModal.svg"
          alt=""
          @click="$emit('closeModal')"
        />
      </div>
      <div class="addDescription__body">
        <div class="container">
          <ReservationInfo
            :active-delivery="activeDelivery"
            :is-add-description="isAddDescription"
          />
          <div class="addDescription__body-description">
            <FormKit
              id="description-form"
              v-model="formData"
              type="form"
              :actions="false"
              @submit="submitHandler"
            >
              <label class="label-description" for="description">
                {{ $t('description') }}
              </label>
              <textarea
                id="description"
                v-model="activeDelivery.descriptionText"
                class="input-description"
                maxlength="250"
                :disabled="!isAddDescription"
              >
              </textarea>
            </FormKit>
          </div>
        </div>
        <InfoAboutActionLog
          v-if="openInfoAboutActionLog"
          :active-delivery="activeDelivery"
        />
      </div>
      <div class="addDescription__buttons">
        <Button
          v-if="activeDelivery.actionsLog"
          variant="filled"
          :title="
            $t(openInfoAboutActionLog ? 'hideFullHistory' : 'showFullHistory')
          "
          @click="showInfoAboutActionLog"
        />
        <div class="addDescription__buttons-block">
          <Button
            v-if="isAddDescription"
            class="isAddDescription"
            variant="filled"
            :title="$t('save')"
            @click="saveDescription"
          />
          <Button
            variant="bordered"
            :title="$t('cancel')"
            @click="$emit('closeModal')"
          />
        </div>
      </div>
    </div>
  </Modal>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { mapActions } from 'vuex';

import Loading from '@/views/Loading.vue';
import ReservationInfo from '@/duplicatePages/ReservationInfo/ReservationInfo.vue';
import InfoAboutActionLog from './InfoAboutActionLog/InfoAboutActionLog.vue';

@Options({
  name: 'AddDescription',
  props: [
    'showModal',
    'activeDelivery',
    'boxId',
    'updateList',
    'isAddDescription'
  ],
  emits: ['updateList'],
  components: {
    ReservationInfo,
    InfoAboutActionLog,
    Loading
  },
  data() {
    return {
      loading: false,
      openInfoAboutActionLog: false,
      formData: {
        reservedTime: 0,
        descriptionText: ''
      }
    };
  },
  methods: {
    ...mapActions('pharmacy', ['updateDescription']),
    async submitHandler() {
      this.loading = true;

      const deliveryId = this.activeDelivery?.deliveryId;

      const { id } = this.$route.params;

      if (this.boxId) {
        const payload = {
          descriptionText: this.activeDelivery.descriptionText,
          reservedTime: this.activeDelivery.reservedTime,
          pickupboxId: this.boxId,
          docId: this.activeDelivery.docId
        };
        await this.updateDescription({
          data: payload,
          deliveryId
        });
      } else {
        const payload = {
          descriptionText: this.activeDelivery.descriptionText,
          reservedTime: this.activeDelivery.reservedTime,
          pharmacyId: id,
          docId: this.activeDelivery.docId
        };
        await this.updateDescription({
          data: payload,
          deliveryId
        });
      }

      this.loading = false;

      this.$emit('updateList');
      this.$emit('closeModal');
    },
    saveDescription() {
      this.$formkit.submit('description-form');
    },
    showInfoAboutActionLog() {
      this.openInfoAboutActionLog = !this.openInfoAboutActionLog;
    }
  }
})
export default class AddDescription extends Vue {}
</script>

<style lang="scss" scoped>
.addDescription {
  max-width: 700px;
  height: 100%;
  padding: 24px;
  .addDescription__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 23px;
    .title {
      font-family: 'Ubuntu-Medium';
      font-size: $eighteenSize;
      line-height: $fifteenSize;
    }
    img {
      cursor: pointer;
    }
  }
  .addDescription__body {
    display: flex;
    flex-direction: column;
    margin-bottom: 24px;
    .container {
      display: flex;
      justify-content: space-between;
      width: 100%;
      .addDescription__body-description {
        position: relative;
        width: 353px;
        height: 278px;
        margin-left: 16px;
        label {
          position: absolute;
          font-family: 'Ubuntu-Regular';
          top: -6px;
          left: 15px;
          padding: 0 5px;
          background: $white;
          color: $label;
          font-weight: 400;
          font-size: $twelveSize;
          line-height: $fourteenSize;
          z-index: 1;
        }
        textarea {
          width: 319px;
          height: 246px;
          padding: 16px;
          font-size: $fourteenSize;
          border: 1px solid $border;
          border-radius: 8px;
          resize: none;
          &:focus {
            outline: none;
          }
        }
      }
    }
  }
  .addDescription__buttons {
    display: flex;
    justify-content: space-between;
    .addDescription__buttons-block {
      .isAddDescription {
        margin-right: 12px;
      }
    }
  }
}
</style>
